import axios from "axios";

import configuration from "../configuration";

const authorizedRequest = async (endpoint: string, host, options: any) => {
  const hostWithDefaults = host.trim().length ? host : configuration["TrustpilotApi.Host"];

  return axios({
    url: `${hostWithDefaults}${endpoint}`,
    ...options,
  });
};

export const get = (url: string, options = {}, host = "") =>
  authorizedRequest(url, host, {
    method: "GET",
    ...options,
  });

export const post = (url: string, options = {}, host = "") =>
  authorizedRequest(url, host, {
    method: "POST",
    ...options,
  });
